import React, { memo } from 'react';
import FileOutlined from '@haier/icons/FileOutlined';
import classNames from 'classnames';
const FloatButtonContent = (props) => {
    const { icon, description, prefixCls, className } = props;
    const defaultElement = (React.createElement("div", { className: `${prefixCls}-icon` },
        React.createElement(FileOutlined, null)));
    return (React.createElement("div", { onClick: props.onClick, onFocus: props.onFocus, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, className: classNames(className, `${prefixCls}-content`) }, icon || description ? (React.createElement(React.Fragment, null,
        icon && React.createElement("div", { className: `${prefixCls}-icon` }, icon),
        description && React.createElement("div", { className: `${prefixCls}-description` }, description))) : (defaultElement)));
};
export default memo(FloatButtonContent);
